const color = {
  primary: {
    light: "#E04E39",
    main: "#c8102e",
    dark: "#BD0F2B",
    contrastText: "#FFFFFF",
  },
  secondary: {
    light: "#E7FBFE",
    main: "#0091C2",
    dark: "#4E6E7D", // Colors updated to achieve 3.0 or 4.5 contrast ratio per WCAG 2.1
    contrastText: "#FFFFFF",
    link: "#007EA8",
    contrastShadow: "#0095C7",
    gradientStart: "#217FA1",
    starBackground: "black",
  },
  text: {
    primary: "#262626",
    secondary: "#333333",
    tertiary: "#888",
    contrastText: "#6E6E6E",
  },
  accredGreen: "#5E7637",
  white: "#ffffff",
  subtle: "#9ea2a2",
  gray: "#adced9",
  skyBlue: "#00A1C9", // Updated from original #00a9e0 to achieve at least 3.0 contrast
  dirtyWhite: "#F2F2F0",
  anotherBlack: "#111",
  subTitleGray: "#707372",
  verySubtle: "#54585a",
  onHover: "#09c",
};

export { color };
